import { ChangeDetectionStrategy, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Order } from '@app/core/api-client/models';
import { CommandsHelper, CommandStatus } from '../../helpers/commands-helper';

@Component({
    selector: 'app-command-detail-state',
    templateUrl: './command-detail-state.component.html',
    styleUrls: ['./command-detail-state.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CommandDetailStateComponent implements OnChanges {

  @Input() order: Order;

  commandStatus: CommandStatus;

  constructor() { }

  // ngOnInit(): void {
  //   // this.commandStatus = CommandsHelper.getCommandStatutLabel(this.order.status);
  //   this.commandStatus = CommandsHelper.getOrderProcessingStep(this.order?.processingState.step);
  // }

  ngOnChanges(changes: SimpleChanges): void {
    // eslint-disable-next-line @typescript-eslint/dot-notation
    if (changes['order']) {
      // this.commandStatus = CommandsHelper.getCommandStatutLabel(this.order?.status);
      this.commandStatus = CommandsHelper.getOrderProcessingStep(this.order?.processingState.step);
    }
  }


}
